import { render, staticRenderFns } from "./agreement.vue?vue&type=template&id=4475cc15&scoped=true"
import script from "./agreement.vue?vue&type=script&lang=ts"
export * from "./agreement.vue?vue&type=script&lang=ts"
import style0 from "./agreement.vue?vue&type=style&index=0&id=4475cc15&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4475cc15",
  null
  
)

export default component.exports